import * as React from "react";
import { FC, PropsWithChildren } from "react";

import { nullElement } from "../../../TypingUtils";

interface IfProps {
    condition: boolean;
}

export const If: FC<PropsWithChildren<IfProps>> = ({ condition, children }) =>
    condition ? <>{children}</> : nullElement;
